export default (eventName, props = {}) => {
  if (typeof window === "undefined") return;
  const server = props.server || (window.s && window.s.server);

  const commonProps = {
    pageName: `${server}|premier`,
    prop1: "discover | premier",
    prop8: "discover | premier",
    channel: "premier",
    prop31: props.loginStatus,
    eVar10: props.customerId,
    eVar141: props.eVar141,
  };

  const config = {
    "page-load": {
      linkVars: {
        prop8: commonProps.pageName,
        eVar15: commonProps.pageName,
        eVar60: commonProps.pageName,
        eVar61: commonProps.pageName,
        ...commonProps,
      },
    },
  };
  return config[eventName];
};
